export enum EBreakpoint {
    TABLET_PORTRAIT = 670,
    TABLET = 960,
    TABLET_WIDE = 1024,
    DESKTOP = 1280
}
export const DEFAULT_MAP_KEY: string = 'd3c864b6-01f3-4748-b63c-688875219392';

export const RESIZE_EVENTS: string[] = ['resize', 'orientationchange'];
